import React, { Fragment, useState, useEffect } from 'react'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCashRegister,
    faCopyright,
    faPlus,
} from '@fortawesome/free-solid-svg-icons'

// router
import { withRouter } from 'react-router-dom'

// formik
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Select from 'react-select'

// services
import { savePuntoVentas } from '../../Services/puntoVentaService'
import { saveError } from '../../Services/errorService'
import { getAllBackofficeDatoFiscales } from '../../Services/backofficeService'
import useBackofficeListsForTenant from './hooks/useBackofficeListsForTenant'
import useMagentaTenantGuard from './hooks/useMagentaTenantGuard'

// components
import Swal from 'sweetalert2'
import Header from '../Header/Header'

function AddPuntoVenta({ history, location }) {
    const { tenantId, tenantNombre } = useMagentaTenantGuard(history, location)
    const {
        sucursales,
        puntoVentas,
        loading: loadingBackoffice,
    } = useBackofficeListsForTenant(tenantId)

    const [datoFiscales, setDatoFiscales] = useState([])

    const formik = useFormik({
        initialValues: {
            nombre: '',
            ip: '',
            sucursal: {},
            datoFiscal: {},
            puntoVenta: '',
        },
        validationSchema: Yup.object({
            nombre: Yup.string().required('El nombre es requerido'),
            ip: Yup.string(),
            sucursal: Yup.object().required('La sucursal es requerida'),
            puntoVenta: Yup.string(),
        }),
        onSubmit: (values) => addPuntoVentaSubmit(values),
    })

    useEffect(() => {
        const input = document.getElementById('inputNombre')
        if (input) input.focus()
    }, [])

    useEffect(() => {
        if (!tenantId) {
            setDatoFiscales([])
            return
        }
        getAllBackofficeDatoFiscales(tenantId, true, 0, '', 500)
            .then((res) => setDatoFiscales(res.data.content || []))
            .catch((err) => {
                console.log('error', err)
                setDatoFiscales([])
            })
    }, [tenantId])

    const addPuntoVentaSubmit = (values) => {
        if (!values.datoFiscal || Object.keys(values.datoFiscal).length === 0) {
            Swal.fire({
                text: 'Debe seleccionar un dato fiscal.',
                icon: 'error',
                confirmButtonText: 'Aceptar',
            })
            return
        }

        savePuntoVentas({
            nombre: values.nombre,
            sucursalId: values.sucursal?.id || null,
            ip: values.ip || '',
            datoFiscalId: values.datoFiscal.id,
            puntoVenta: values.puntoVenta,
            tenantId,
        })
            .then(() => {
                Swal.fire({
                    text: 'Punto de venta creado con éxito.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                })
                history.goBack()
            })
            .catch(async (error) => {
                const errorData = {
                    mensaje: 'Error al intentar crear un punto de venta',
                    detalle: error.message,
                    entidad: 'PUNTO_VENTA',
                    tipo: 'WEBAPP',
                    severidad: 'HIGH',
                    reportado: 'APPLICATION',
                }

                await saveError(errorData)
                Swal.fire({
                    text: 'Error al crear el punto de venta, verifique los datos.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar',
                })
                console.error(error)
            })
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faCashRegister}
                        title={
                            tenantNombre
                                ? `Punto de Venta — ${tenantNombre}`
                                : 'Punto de Venta'
                        }
                    />
                </div>

                <div className="bg-gris p-4">
                    {!loadingBackoffice ? (
                        <p className="text-muted small mb-3">
                            Recursos del tenant: {sucursales.length} sucursales,{' '}
                            {puntoVentas.length} puntos de venta,{' '}
                            {datoFiscales.length} datos fiscales.
                        </p>
                    ) : null}
                    <form onSubmit={formik.handleSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputNombre">Nombre</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCopyright} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputNombre"
                                        name="nombre"
                                        className="form-control"
                                        placeholder="Ej. Coca Cola, Bimbo..."
                                        value={formik.values.nombre}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.nombre &&
                                formik.errors.nombre ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.nombre}
                                    </small>
                                ) : null}
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="inputIp">Ip</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCopyright} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputIp"
                                        name="ip"
                                        className="form-control"
                                        placeholder="127.0.0.1"
                                        value={formik.values.ip}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.ip && formik.errors.ip ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.ip}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputSucursal">Sucursal</label>
                                <div>
                                    <Select
                                        placeholder={'Seleccionar una sucursal'}
                                        options={sucursales}
                                        onChange={(value) =>
                                            formik.setFieldValue(
                                                'sucursal',
                                                value
                                            )
                                        }
                                        getOptionValue={(values) => values.id}
                                        getOptionLabel={(values) =>
                                            values.nombre
                                        }
                                    ></Select>
                                </div>
                                {formik.touched.sucursal &&
                                formik.errors.sucursal ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.sucursal}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputDatoFiscal">
                                    Dato Fiscal
                                </label>
                                <div>
                                    <Select
                                        placeholder={
                                            'Seleccionar una certificado'
                                        }
                                        options={[
                                            {
                                                id: null,
                                                razonSocial: 'Ninguno',
                                            },
                                            ...datoFiscales,
                                        ]}
                                        onChange={(value) =>
                                            formik.setFieldValue(
                                                'datoFiscal',
                                                value
                                            )
                                        }
                                        getOptionValue={(values) => values.id}
                                        getOptionLabel={(values) =>
                                            values.razonSocial
                                        }
                                    ></Select>
                                </div>
                                {formik.touched.datoFiscal &&
                                formik.errors.datoFiscal ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.datoFiscal}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputPuntoVenta">
                                    Punto de Venta
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faCashRegister}
                                        />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputPuntoVenta"
                                        name="puntoVenta"
                                        className="form-control"
                                        placeholder="Ej. 0001"
                                        value={formik.values.puntoVenta}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.puntoVenta &&
                                formik.errors.puntoVenta ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.puntoVenta}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Crear Punto
                                Venta
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddPuntoVenta)
